import { render, staticRenderFns } from "./CaseSet.vue?vue&type=template&id=6245572e&scoped=true"
import script from "./CaseSet.vue?vue&type=script&lang=js"
export * from "./CaseSet.vue?vue&type=script&lang=js"
import style0 from "./CaseSet.vue?vue&type=style&index=0&id=6245572e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6245572e",
  null
  
)

export default component.exports